<ng-container *ispDynamicFormTemplate="'buttons'; let field">
  <ng-container *ngIf="footerButtons$ | async as buttons">
    <footer *ngIf="buttons.length && showFooter">
      <isp-form-buttons
        [buttons]="getVisibleFooterButtons(buttons)"
        [hintAttachSelector]="'.form__footer' | formIdPrefix"
        [hintPlacementOrder]="['top', 'right', 'rightBottom']"
        (btnClick)="emitButtonClick($event)"
      ></isp-form-buttons>
    </footer>
  </ng-container>
</ng-container>

<form
  *ngIf="formGroup$ | async as formGroup"
  [formGroup]="formGroup"
  [id]="formId"
  class="form"
  autocomplete="off"
>
  <formly-form
    class="form__formly-component"
    [form]="formGroup"
    [model]="model$ | async"
    [fields]="configs$ | async"
    [options]="options$ | async"
    (keyup.enter)="submitFromKeyboard($event)"
    [tabindex]="-1"
  ></formly-form>
</form>
